import { FC, useEffect, useState } from "react";
import "./Avatar.css";
import UserIcon from "../../../assets/avatar.svg";
import { getAvatarUrlFromId } from "../../../helpers/getFileUrlFromId";
import { eventService } from "../../../events/EventServise";

export enum AvatarSize {
    xxl = "xxl",
    xl = "xl",
    lg = "lg",
    m = "m",
    s = "s",
}

interface IAvatar {
    userId?: number;
    size?: AvatarSize;
    userName?: string;
    className?: string;
    srcBase64?: string;
}

const Avatar: FC<IAvatar> = ({ userId, size, userName, className, srcBase64 }) => {
    const [timestamp, setTimestamp] = useState(Date.now());

    useEffect(() => {
        const handlePhotoUpdate = (data: { userId: number | undefined }) => {
            if (data.userId === userId) {
                setTimestamp(Date.now());
            }
        };

        eventService.on('userPhotoUpdated', handlePhotoUpdate);

        return () => {
            eventService.off('userPhotoUpdated', handlePhotoUpdate);
        };
    }, [userId]);

    const getAvatarUrl = () => {
        if (!userId) return UserIcon;
        // return `${getAvatarUrlFromId(userId)}?t=${timestamp}`;
        return `${getAvatarUrlFromId(userId)}`;
    };

    return (
        <div className={className}>
            <img
                id={`${userId}`}
                className={`avatar ${size}`}
                src={srcBase64 ?? (userId ? getAvatarUrl() : UserIcon)}
                alt={userName}
                title={userName}
                onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = UserIcon;
                }}
            />
        </div>
    );
};

export default Avatar;
